// routes/_app.profile.edit.api.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.api')

export const handle = {
  name: 'profile/edit/api',
  track: { scene: 'profile-edit', section: 'api' },
}

export default dynamic(getClientModule, { ssr: false })
